module.exports = __webpack_public_path__ + "static/media/M2C.0480f234.png";